const DISABLED_MODE = -1

// 改图模式 -1为未开发功能
const REDRAW_MODE = {
  REPLACE: 0, // 重绘
  ERASE: 1, // 擦物体
  CHANGE_MATERIAL: 2, // 改材质
  CHANGE_COLOR: 4, // 改颜色
  CHANGE_STYLE: 5, // 改风格
  WEATHER: 15, // 调天气
  COLOR_MIXING: 9, // 调色
  ADD_OBJ: 12, // 加物体
  ADD_MODEL: 14, // 加人物
  LIGHT: 11, // 调光线
  CUTOUT: 6, // 抠图
  BG: 16, // 换背景
  ZOOM: 3, // 超清放大-高清hd
  EXPAND: -1, // 扩图
  CLIP: 10, // 裁剪
  REMOVE_WATERMARK: 7, // 去水印
  ADD_WATERMARK: 8, // 加水印
  SMART_MARK: 13, // 标注 
  DETAIL_ENHANCER: 19, // 细节增强
  DRAW: 20 // 绘图
}

// 改图工具条
const TOOLBAR = {
  DRAG: 'drag', // 画布拖拽
  AI_PAINT: 'ai-paint', // AI选区-选择
  AI_REMOVE: 'ai-remove', // AI选区-取消选择
  MANU_PAINT: 'manu-paint', // 手动涂抹
  ERASE: 'erase', // 橡皮擦
  REMOVE_BG: 'remove-bg', // 智能去背景
  MANUAL_PICK: 'manual-pick', // 抠图 手动 + 擦除
  MANUAL_CLEAR: 'manual-clear', // 抠图 手动 + 保留
  AI_PICK: 'ai-pick', // 抠图 自动 + 擦除
  AI_CLEAR: 'ai-clear', // 抠图 自动 + 保留
  NONE: 'none' // 无
}


// 改图working状态
const WORKING_STATUS = {
  START: 'start', // 开始状态(发起改图接口时候)
  QUENING: 'quening', // 排队中
  DOING: 'doing', // 创作中
  WAITING: 'waiting', // 等待状态(创作超过了3s)
  DONE: 'done' // 已完成
}

const AUTO_AREA_TYPE = 1 // 自动涂抹类型
const MANUAL_AREA_TYPE = 2 // 手动涂抹类型
const HOVER_AREA_TYPE = 3 // 鼠标悬浮涂抹类型
const CLEAR_AREA_TYPE = 4 // 橡皮擦擦除类型
const CUTOUT_AI_CACHU = 5 // 抠图 AI 擦除
const CUTOUT_AI_BAOLIU = 6 // 抠图 AI 保留
const CUTOUT_AI_BG = 7 // 抠图 AI 智能去背景
// AUTO_AREA_TYPE | MANUAL_AREA_TYPE | HOVER_AREA_TYPE | CLEAR_AREA_TYPE | CUTOUT_AI_CACHU | CUTOUT_AI_BAOLIU
type AreaType = 1 | 2 | 3 | 4 | 5 | 6 | 7

const AUTO_PAINT = 'auto-paint'
const MIXED_DATA = 'mixed-data'

const CTRL_WHEEL = {
  SCALE_MODE: 0,
  PENCIL_MODE: 1,
  ERASER_MODE: 2
}

const aiAreaTypeMap = {
  [TOOLBAR.AI_CLEAR]: CUTOUT_AI_BAOLIU,
  [TOOLBAR.AI_PICK]: CUTOUT_AI_CACHU,
  default: AUTO_AREA_TYPE,
  [TOOLBAR.AI_REMOVE]: CUTOUT_AI_BAOLIU,
}

// canvas resize mode
const canvasResize = {
  CONTRAST: 0, // 切换底部小图、查看比对
  SHOW_BOTTOM_LIST: 1, // 显示底部小图列表，场景：非擦除物体模式下改图进行中
  SHOW_BOTTOM_LIST_AND_TOOLBOX: 2, // 显示底部小图列表(非擦除物体模式)和顶部图片工具箱，场景：改图完成时、切换保存记录图片
  HIDE_BOTTOM_LIST_AND_TOOLBOX: 3, // 不显示底部小图列表和顶部图片工具箱，场景：重新上传图片、复制指令
  CLIP: 4
}

const CANVAS_IMAGE_ACTION = {
  INIT: 'init',
  COPY: 'copy',
  CLEAR: 'clear',
  FILL: 'fill',
  RESET: 'reset'
}
const WATERMARK_STYLE = {
  IMAGE: 1,
  TEXT: 2,
  INTERNAL_TEXT1: 3,
  INTERNAL_TEXT2: 4,
  INTERNAL_TEXT3: 5
}

const BRUSH_MODE = {
  PAINT: 'paint',
  ERASE: 'erase'
}

const BRUSH_TOOL = {
  PENCIL: 'pencil', // 画笔
  CIRCLE: 'circle', // 圆形
  RECT: 'rect',     // 矩形
  LINE: 'line',     // 直线
  LASSO: 'lasso'    // 套索
};

// export type BrushToolType = typeof BRUSH_TOOL;

// 标注类型
const MARK_TYPE: any = {
  structure: 1,
  text: 2,
  screen: 3,
  floor: 4,
  av: 5
}
// 标注类型对应的标注内容text
const MARK_CONTENT_TEXT: any = {
  1: '结构',
  2: '文字',
  3: '画面',
  4: '地面',
  5: 'AV'
}
// 标注类型对应的标注内容
const MARK_CONTENT_LIST: any = {
  1: ['防火板', '涂料', '烤漆', '贴纸', '挂板', '铝明板', '软膜', '绷布'],
  2: ['亚克力发光字', '不锈钢包边发光字', '阴刻发光字', '吸塑发光字', '树脂发光字', '即时贴字', '亚克力字', '雪弗板字', '金属字'],
  3: ['写真', '侧发光写真', '灯片发光灯箱', '软膜发光灯箱', '亚克力发光灯箱', '地贴'],
  4: ['三聚氰胺板', '淋油板', '复合地板', '玻璃地台', '拉绒地毯', '圈绒地毯', '割绒地毯'],
  5: ['LED拼屏', 'LED电视', '冰屏', '彩幕', 'LED灯带', '亚克力发光灯带']
}
// 标注类型对应的标注内容主题色
const MARK_CONTENT_COLOR: any = {
  1: '#E8698F',
  2: '#FD8B6D',
  3: '#FBC251',
  4: '#9EDBDE',
  5: '#B9C7F4'
}

const ADID_IMAGEURL_MAP = {
  1: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750239151310.jpg',
  2: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750238976087.jpg',
  3: 'https://imgo.3d66.com/ai/reference_image/202507/179175740_1751534689991.png',
  4: 'https://imgo.3d66.com/ai/reference_image/202507/179175740_1751453611758.png',
  5: 'https://imgo.3d66.com/ai/reference_image/202507/179175740_1751613851807.png',
  6: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750300799254.jpg',
  7: 'https://imgo.3d66.com/ai/reference_image/202507/179175740_1751618003450.png',
  8: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750239180458.jpg',
  9: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750238941441.jpg',
  10: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750239089876.jpg',
}

export {
  REDRAW_MODE,
  TOOLBAR,
  WORKING_STATUS,
  AUTO_AREA_TYPE,
  MANUAL_AREA_TYPE,
  HOVER_AREA_TYPE,
  CLEAR_AREA_TYPE,
  CUTOUT_AI_CACHU,
  CUTOUT_AI_BAOLIU,
  CUTOUT_AI_BG,
  AUTO_PAINT,
  MIXED_DATA,
  CTRL_WHEEL,
  aiAreaTypeMap,
  type AreaType,
  canvasResize,
  CANVAS_IMAGE_ACTION,
  WATERMARK_STYLE,
  BRUSH_MODE,
  BRUSH_TOOL,
  MARK_TYPE,
  MARK_CONTENT_TEXT,
  MARK_CONTENT_LIST,
  MARK_CONTENT_COLOR,
  DISABLED_MODE,
  ADID_IMAGEURL_MAP
}
